import React, { useContext, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { StepperContext, EWContext } from "../../context/EWContext";
import ReactGA from "react-ga4";
import { LANGUAGE_TEXT } from "../../constants";

const divSubmitStyle = makeStyles(() => ({
   buttonStyle: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      position: "sticky",
      background: "#FFFFFF",
      top: 1,
      bottom: "-30px",
      zIndex: 10,
   },
}));

const useStyles = makeStyles((theme) => ({
   wrapper: {
      margin: theme.spacing(1, 0),
      position: "relative",
   },
   buttonProgress: {
      color: "primary",
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
   },
}));

export default function StepperNavigationButtons(props) {
   const stepperState = useContext(StepperContext)[0];
   const activeStep = stepperState.activeStep;
   const steps = stepperState.steps;
   const classes = useStyles();
   const buttonStyle = divSubmitStyle();
   const { buttonNameOnSummary } = props;
   const [accountState] = useContext(EWContext);

   const measurementTagId =
      accountState?.googleAnalytics?.measurementTagId || false;

   useEffect(() => {
      if (measurementTagId && !ReactGA.isInitialized) {
         ReactGA.initialize(measurementTagId);
      }
   }, []);

   useEffect(() => {
      if (measurementTagId) {
         ReactGA.gtag("event", "ver_progress", {
            ver_step:
               steps.length === activeStep.index + 1
                  ? `step_${activeStep.index + 1}_final`
                  : `step_${activeStep.index + 1}`,
         });
      }
   }, [activeStep]);

   return (
      <Grid
         item
         xs={12}
         sm={12}
         md={12}
         lg={12}
         xl={12}
         className={buttonStyle.buttonStyle}
      >
         <div className={classes.wrapper}>
            <Button
               onClick={props.handleBack}
               variant="contained"
               color="secondary"
               role="button"
            >
               {accountState?.conditionSpecificBehaviors?.translateText &&
               accountState?.storeInfo?.languageCode
                  ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                       ?.back_button_text
                  : "Back"}
            </Button>
         </div>
         <div className={classes.wrapper}>
            <Button
               variant="contained"
               color="primary"
               type="submit"
               role="button"
               onClick={props.handleNext}
               disabled={props.nextButtonDisabled || props.loading}
            >
               {activeStep.index === steps.length - 1
                  ? buttonNameOnSummary
                     ? (accountState?.conditionSpecificBehaviors?.translateText &&
                     accountState?.storeInfo?.languageCode
                        ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                             ?.step2_confirm
                        : "Step 2: Confirm")
                     : (accountState?.conditionSpecificBehaviors?.translateText &&
                     accountState?.storeInfo?.languageCode
                        ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                             ?.confirm
                        : "Confirm")
                  : accountState.show_throbber_processing_text &&
                    props.loading &&
                    activeStep.id === "validate"
                  ? "Processing..."
                  : accountState?.conditionSpecificBehaviors?.translateText &&
                    accountState?.storeInfo?.languageCode
                  ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                       ?.next_button_text
                  : "Next"}
            </Button>
            {props.loading && (
               <CircularProgress size={24} className={classes.buttonProgress} />
            )}
         </div>
      </Grid>
   );
}
